(ns common.resource.query.backup-image
  (:require [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn backup-images-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["backup-images" advertiser-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/advertiser-backup-images
                                           {:advertiser-id advertiser-id})))
       :staleTime (* 60 1000)
       :enabled (some? advertiser-id)})

(defn upload-backup-image-mutation [{:keys [advertiser-id dimensions]}]
  #js {:mutationKey #js ["upload-backup-image" advertiser-id dimensions]
       :mutationFn (fn [payload]
                     (qhttp/post (qhttp/render :api/advertiser-backup-image-upload
                                               {:advertiser-id advertiser-id
                                                :dimensions dimensions})
                                 {:body payload
                                  :format :form-data}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSuccess (fn []
                    (rf/dispatch [:ocp/close])
                    (rf/dispatch [:loader/close])
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "Backup Image"
                                   :type :success}])
                    (invalidate-queries {:queryKey ["backup-images" advertiser-id]}))
       :onError (fn [error]
                  (rf/dispatch [:loader/close])
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Backup Image"
                                 :type :error
                                 :event :upload-backup-image/failure
                                 :response error}]))})
